module.exports = {
  __depends__: [
    require(159)
  ],
  dragging: [ 'type', require(105) ]
};